import { useEffect, useState } from "react";
import { ProfileDetail } from "../../../services/webServices/user-detail/types";
import logoFormic from "../../../assets/icons/logoformic.webp";

const HEADER_LOGO_CLASS =
  "h-9 w-auto max-w-[140px] object-contain object-center shrink-0";

export default function AdminLayoutHeader() {

  const [profileInfo, setProfileInfo] = useState<ProfileDetail>();

  useEffect(() => {
    let info = localStorage.getItem("profileInfo");
    info && setProfileInfo(JSON.parse(info));
  }, []);

  return (
    <div className="w-full flex flex-row justify-between" dir="rtl">
      <img
        src={logoFormic}
        alt="سپهرجو"
        className={HEADER_LOGO_CLASS}
      />
      <div className=" flex flex-row gap-3">
        <div className="profile-pic-container">
          <img
            src={
              profileInfo?.profile?.avatar
                ? `${process.env.REACT_APP_File_URL}${profileInfo.profile?.avatar}`
                : "/images/avatar-alt.jpg"
            }
            alt="Profile Picture"
            className="profile-pic"
          />
        </div>
      </div>
    </div>
  );
};